<template>
  <div class="bg-neutral-100">
    <div class="container py-8 lg:py-10">
      <div class="lg:pb-6">
        <ArticleFilter class="mb-6" :categories="store.allCategories" is-shop-filter />
      </div>
      <div class="min-h-[600px]">
        <div class="grid-default pt-6 lg:pt-7">
          <div
            v-for="(product, index) in store.allProducts"
            :key="index"
            class="col-span-3 mb-4 lg:col-span-4 lg:mb-24"
          >
            <ProductCard :data="product" />
          </div>
        </div>
        <div v-if="store.isLoading" class="py-10 text-center">
          <Spinner class="mx-auto mt-10" />
        </div>

        <div v-else-if="store.loadMore" class="flex justify-center pb-14 pt-8 lg:py-24">
          <Button
            :label="$t('Load more products')"
            :variant="'solid'"
            :icon="{
              name: 'arrow-right',
              size: 'sm',
              color: 'white'
            }"
            @click="store.fetchArticles(locale, categoryID)"
          />
        </div>

        <div v-else-if="store.isEmpty">
          <div class="my-10 text-center text-4xl">{{ $t('articles.empty') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useShopStore } from '~/stores/ShopStore'
import type { SectionShopProductListRecord } from '~/types/generated'

const props = defineProps({
  data: {
    type: Object as PropType<SectionShopProductListRecord>,
    default: () => {}
  }
})

const route = useRoute()
const store = useShopStore()
const { locale } = useI18n()
const categoryID = computed(() => store.getCategoryByName(route.query.category)?.id)

watch(
  () => route.query,
  () => {
    loadData()
  }
)

function loadData() {
  store.setLoading(true)

  if (route.query.category) {
    if (route.query.category !== store.allFilters) {
      store.resetArticles()
    }

    // Get filterID
    const { id } = store.getCategoryByName(route.query.category)
    store.pushFilters(route.query.category)

    // Filtered by Category
    store.fetchArticles(locale.value, id)
  } else {
    // Unfiltered / All Articles
    store.pushFilters('')
    store.resetArticles()
    store.fetchArticles(locale.value)
  }
}

onMounted(() => {
  store.setItemsPerPage(props.data.productLimit)

  useTimeoutFn(() => {
    loadData()
  }, 10)
})
</script>
